<div class="counter">
    <span class="counter-btn counter-btn-decrease" @click="decrease">-</span>
    <span class="counter-val">{{ mutableValue }}</span>
    <span class="counter-btn counter-btn-increase" @click="increase">+</span>
</div>
